export default class CodecService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('codecs', params)
	}

	createEntity(params){
		return this.apiService.callPost('codecs', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('codecs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/CodecService.js